(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baby-vergleich"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('kz-comparison-stage')) return;
  class KzComparisonStage extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.frame = requestAnimationFrame(() => this.init());
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true, signal: this.signal });
    }
    init() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.rows = Array.from(this.querySelectorAll('[data-comparison-row]'));
      this.status = this.querySelector('[data-comparison-status]');
      this.tabs = this.querySelector('[data-stage-tabs]');
      this.panels = this.querySelector('[data-comparison-list]');
      this.selector = this.querySelector('[data-comparison-filter]');
      this.buttons = this.rows.map((row, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.id = 'KzStageTab-' + this.dataset.sectionId + '-' + row.dataset.blockId;
        button.dataset.stageTab = String(index);
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', row.id);
        button.setAttribute('aria-selected', 'false');
        button.tabIndex = -1;
        const number = document.createElement('span');
        number.className = 'kzstage__tab-number';
        number.setAttribute('aria-hidden', 'true');
        number.textContent = String(index + 1).padStart(2, '0');
        const label = document.createElement('span');
        label.textContent = row.querySelector('h3').textContent;
        button.append(number, label);
        row.setAttribute('role', 'tabpanel');
        row.setAttribute('aria-labelledby', button.id);
        row.tabIndex = 0;
        return button;
      });
      this.tabs.replaceChildren(...this.buttons);
      this.tabs.hidden = this.rows.length === 0;
      this.querySelector('[data-comparison-tools]').hidden = this.rows.length === 0;
      if (this.selector) {
        const groups = new Set(this.rows.map(row => row.dataset.category));
        Array.from(this.selector.options).forEach(option => { option.hidden = option.value !== 'all' && !groups.has(option.value); });
        this.querySelector('[data-comparison-filters]').hidden = groups.size < 2;
        this.selector.addEventListener('change', () => this.filter(this.selector.value), { signal: this.signal });
      }
      this.addEventListener('click', event => this.onClick(event), { signal: this.signal });
      this.tabs.addEventListener('keydown', event => {
        const button = event.target.closest('[data-stage-tab]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = this.visibleRows.indexOf(this.rows[Number(button.dataset.stageTab)]);
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.visibleRows.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.visibleRows.length) % this.visibleRows.length;
        this.select(target, true, true);
      }, { signal: this.signal });
      this.panels.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' || !event.isPrimary || event.target.closest('a,button,input,select,textarea')) return;
        this.startPointer = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, { passive: true, signal: this.signal });
      this.panels.addEventListener('pointerup', event => {
        const start = this.startPointer;
        this.startPointer = null;
        if (!start || start.id !== event.pointerId || document.getSelection()?.toString()) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) < 55 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        this.select(this.activeIndex + (dx < 0 ? 1 : -1));
      }, { passive: true, signal: this.signal });
      this.panels.addEventListener('pointercancel', () => { this.startPointer = null; }, { signal: this.signal });
      document.addEventListener('shopify:block:select', event => {
        const row = this.rows.find(node => node.dataset.blockId === event.detail?.blockId);
        if (!row) return;
        this.filter('all', false);
        this.select(this.visibleRows.indexOf(row), false, false);
        const top = Math.max(0, window.scrollY + this.tabs.getBoundingClientRect().top - Number(this.dataset.scrollOffset || 96));
        window.scrollTo({ top, behavior: 'auto' });
      }, { signal: this.signal });
      this.dataset.enhanced = 'true';
      const restore = this.selectedBlockId;
      this.filter('all', false);
      const restoredIndex = this.visibleRows.findIndex(row => row.dataset.blockId === restore);
      if (restoredIndex > 0) this.select(restoredIndex, false, false);
    }
    filter(category, announce = true) {
      if (this.selector) this.selector.value = category;
      this.visibleRows = this.rows.filter(row => category === 'all' || row.dataset.category === category);
      this.rows.forEach((row, index) => { this.buttons[index].hidden = !this.visibleRows.includes(row); });
      const count = this.visibleRows.length;
      const format = this.dataset.designMode === 'true' ? this.dataset.previewCount : count === 1 ? this.dataset.countOne : this.dataset.countMany;
      this.querySelector('[data-comparison-count]').textContent = (format || '').replaceAll('{count}', String(count));
      this.querySelector('[data-comparison-reset]').hidden = category === 'all';
      this.select(0, announce, false);
    }
    select(index, announce = true, animate = true) {
      if (!this.visibleRows.length) { this.rows.forEach(row => { row.hidden = true; }); return; }
      const next = Math.max(0, Math.min(index, this.visibleRows.length - 1));
      const row = this.visibleRows[next];
      const direction = next >= (this.activeIndex || 0) ? 1 : -1;
      const changed = this.selectedBlockId !== row.dataset.blockId;
      this.activeIndex = next;
      this.selectedBlockId = row.dataset.blockId;
      this.panelAnimation?.cancel();
      this.rows.forEach((node, i) => {
        const selected = node === row;
        node.hidden = !selected;
        this.buttons[i].setAttribute('aria-selected', String(selected));
        this.buttons[i].tabIndex = selected ? 0 : -1;
      });
      const button = this.buttons[this.rows.indexOf(row)];
      const left = button.offsetLeft;
      const right = left + button.offsetWidth;
      if (left < this.tabs.scrollLeft || right > this.tabs.scrollLeft + this.tabs.clientWidth) {
        this.tabs.scrollTo({ left: Math.max(0, left - 12), behavior: 'instant' });
      }
      if (document.activeElement?.closest('[data-stage-tabs]') === this.tabs) button.focus({ preventScroll: true });
      if (animate && changed && this.dataset.motion === 'true' && !this.reduced.matches && row.animate) {
        this.panelAnimation = row.animate([{ opacity: .65, transform: 'translateX(' + 14 * direction + 'px)' }, { opacity: 1, transform: 'translateX(0)' }], { duration: 240, easing: 'ease-out' });
      }
      const nav = this.querySelector('[data-stage-navigation]');
      const position = (this.dataset.positionTemplate || '{index} / {total}').replaceAll('{index}', String(next + 1).padStart(2, '0')).replaceAll('{total}', String(this.visibleRows.length).padStart(2, '0'));
      if (nav) {
        nav.hidden = this.visibleRows.length < 2;
        nav.querySelector('[data-stage-previous]').disabled = next === 0;
        nav.querySelector('[data-stage-next]').disabled = next === this.visibleRows.length - 1;
        nav.querySelector('[data-stage-position]').textContent = position;
      }
      if (announce) this.querySelector('[data-comparison-announcement]').textContent = row.querySelector('h3').textContent + '. ' + position;
    }
    query(scope, selector) { try { return selector ? scope.querySelector(selector) : null; } catch { return null; } }
    findSource() {
      const id = this.dataset.productId;
      const explicit = this.dataset.sourceSelector;
      if (explicit) {
        const root = this.query(document, explicit);
        if (!root || this.contains(root) || !root.getClientRects().length || (id && root.dataset.productId && id !== root.dataset.productId)) return null;
        return root;
      }
      const roots = Array.from(document.querySelectorAll('[data-kz-main-product],[data-salvation-root][data-salvation-v13]')).filter(root => !this.contains(root) && root.getClientRects().length && (!id || root.dataset.productId === id));
      const preceding = roots.filter(root => root.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING);
      if (preceding.length || roots.length) return preceding.pop() || roots[0];
      if (!id) return null;
      return Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form => {
        if (form.closest('cart-drawer,#CartDrawer,dialog,[role="dialog"]') || this.contains(form) || !form.getClientRects().length) return false;
        const productId = form.querySelector('[name="product-id"]')?.value || form.dataset.productId || form.closest('[data-product-id]')?.dataset.productId;
        return String(productId || '') === id;
      }) || null;
    }
    message(text, focus = false) {
      this.status.textContent = text || '';
      this.status.hidden = !text;
      if (focus && text) this.status.focus({ preventScroll: true });
    }
    scrollToSource(root) {
      const options = root.querySelector('.svb__offers,[data-product-options],variant-selects,variant-radios');
      const target = options?.getBoundingClientRect().height > 0 ? options : root;
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - Number(this.dataset.scrollOffset || 96));
      window.scrollTo({ top, behavior: this.dataset.motion === 'true' && !this.reduced.matches ? 'smooth' : 'auto' });
      const controls = Array.from(target.querySelectorAll('select,input:not([type="hidden"]),button'));
      const control = controls.find(node => !node.disabled && node.getClientRects().length && node.getBoundingClientRect().height > 0) || root.querySelector('[data-atc],button[name="add"]');
      control?.focus({ preventScroll: true });
      this.message(this.dataset.selectionMessage);
    }

    onClick(event) {
      const tab = event.target.closest('[data-stage-tab]');
      if (tab) { this.select(this.visibleRows.indexOf(this.rows[Number(tab.dataset.stageTab)])); return; }
      if (event.target.closest('[data-stage-next]')) { this.select(this.activeIndex + 1); return; }
      if (event.target.closest('[data-stage-previous]')) { this.select(this.activeIndex - 1); return; }
      if (event.target.closest('[data-comparison-reset]')) { this.filter('all'); this.selector?.focus({ preventScroll: true }); return; }
      const link = event.target.closest('[data-comparison-action]');
      if (!link || link.dataset.comparisonAction === 'link' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const source = this.findSource();
      if (source) { event.preventDefault(); this.scrollToSource(source); return; }
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;
      event.preventDefault();
      this.message(this.dataset.missingMessage, true);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.panelAnimation?.cancel();
      cancelAnimationFrame(this.frame);
      this.controller = null;
      this.initialized = false;
      this.startPointer = null;
    }
  }
  customElements.define('kz-comparison-stage', KzComparisonStage);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
